'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

var _constants = require('../../../../constants');

var _RuleSettings = require('./RuleSettings');

var _RuleSettings2 = _interopRequireDefault(_RuleSettings);

var _RuleLogic = require('./RuleLogic');

var _RuleLogic2 = _interopRequireDefault(_RuleLogic);

require('./Builder.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Builder = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Builder, _Component);

  function Builder() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Builder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Builder.__proto__ || (0, _getPrototypeOf2.default)(Builder)).call.apply(_ref, [this].concat(args))), _this), _this.renderSaveButton = function () {
      var _this$props = _this.props,
          savable = _this$props.savable,
          ruleSaving = _this$props.ruleSaving;


      var saveLabel = ruleSaving ? _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'builder.save.button.saving.on.label',
        defaultMessage: 'Saving...'
      }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'builder.save.button.saving.off.label',
        defaultMessage: 'Save Rule'
      });

      var button = _react2.default.createElement(
        _antd.Button,
        {
          className: 'save-or-create-button',
          type: 'primary',
          disabled: !_this.props.savable,
          loading: _this.props.ruleSaving,
          onClick: function onClick() {
            _this.props.builderActions('saveRule');
          }
        },
        saveLabel
      );

      if (!savable) {
        return _react2.default.createElement(
          _antd.Tooltip,
          {
            title: _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'builder.saveButton.tooltip',
              defaultMessage: 'Required fields missing and/or some conditions/tasks have not been saved'
            })
          },
          button
        );
      }

      return button;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Builder, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isPackage = _props.isPackage,
          ruleset = _props.ruleset;

      var rulesetName = ruleset.name || '';
      var ruleSetUrl = isPackage ? '/automation_engine' : '/automation_engine/rule_sets';

      return _react2.default.createElement(
        'div',
        { className: 'builder__component' },
        _react2.default.createElement(
          'div',
          { className: 'build-a-rule-text' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'builder.title.text',
            defaultMessage: 'Rule Builder'
          })
        ),
        _react2.default.createElement(
          _antd.Row,
          { className: 'm-t-5' },
          _react2.default.createElement(
            _antd.Col,
            { span: 20, className: 'ruleset-label' },
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'builder.ruleset.label',
                defaultMessage: 'Rule Set'
              }),
              ':'
            ),
            _react2.default.createElement(
              'span',
              { className: 'ruleset-name' },
              rulesetName
            )
          ),
          _react2.default.createElement(
            _antd.Col,
            { span: 4, className: 'text-align-right' },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: ruleSetUrl },
              _react2.default.createElement(_antd.Icon, { type: 'left' }),
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'builder.backToRuleSets.link',
                defaultMessage: 'Back to Rule Sets'
              })
            )
          )
        ),
        _react2.default.createElement(_RuleSettings2.default, {
          ruleset: ruleset,
          ruleSettings: this.props.ruleSettings,
          entityHierarchy: this.props.entityHierarchy,
          ruleSettingsActions: this.props.ruleSettingsActions,
          currentAdvertiser: this.props.currentAdvertiser,
          scopeEntityType: this.props.scopeEntityType,
          selectedEntityIds: this.props.selectedEntityIds,
          isRuleSettingsValid: this.props.isRuleSettingsValid
        }),
        _react2.default.createElement(_RuleLogic2.default, {
          ruleDetailsActions: this.props.ruleDetailsActions,
          ruleBranches: this.props.ruleBranches,
          editing: this.props.editing,
          meta: this.props.meta,
          ruleSettings: this.props.ruleSettings,
          users: this.props.users,
          builderActions: this.props.builderActions,
          invalidEntities: this.props.invalidEntities
        }),
        this.renderSaveButton()
      );
    }
  }]);
  return Builder;
}(_react.Component), _class.propTypes = {
  ruleDetailsActions: _propTypes2.default.func.isRequired,
  ruleSettingsActions: _propTypes2.default.func.isRequired,
  builderActions: _propTypes2.default.func.isRequired,
  currentAdvertiser: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.number.isRequired
  }).isRequired,
  ruleBranches: _RuleLogic2.default.propTypes.ruleBranches,
  editing: _RuleLogic2.default.propTypes.editing,
  meta: _propTypes2.default.shape(_RuleLogic2.default.propTypes.meta).isRequired,
  entityHierarchy: _propTypes2.default.shape({
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      value: _propTypes2.default.string.isRequired,
      label: _propTypes2.default.string.isRequired,
      children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired,
        children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
          value: _propTypes2.default.string.isRequired,
          label: _propTypes2.default.string.isRequired
        }))
      }))
    })).isRequired,
    loading: _propTypes2.default.bool.isRequired
  }).isRequired,
  ruleSettings: _propTypes2.default.shape(_RuleLogic2.default.propTypes.ruleSettings).isRequired,
  savable: _propTypes2.default.bool,
  ruleSaving: _propTypes2.default.bool.isRequired,
  users: _propTypes2.default.shape(_RuleLogic2.default.propTypes.users).isRequired,
  isPackage: _propTypes2.default.bool.isRequired,
  ruleset: _propTypes2.default.shape({
    name: _propTypes2.default.string,
    id: _propTypes2.default.number,
    startTime: _propTypes2.default.string,
    endTime: _propTypes2.default.string
  }).isRequired,
  scopeEntityType: _propTypes2.default.oneOf(_constants.ENTITY_SCOPE.map(function (entityScope) {
    return entityScope.value;
  })),
  selectedEntityIds: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
  isRuleSettingsValid: _propTypes2.default.bool.isRequired,
  invalidEntities: _propTypes2.default.shape({
    ruleBranches: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
    conditionGroups: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
    conditions: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
    tasks: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))
  }).isRequired
}, _class.defaultProps = {
  editing: {
    conditions: {},
    tasks: {}
  },
  ruleBranches: [],
  scopeEntityType: null,
  selectedEntityIds: [],
  savable: false
}, _temp2);
exports.default = Builder;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Builder/components/Builder.js
// module id = 3768
// module chunks = 4